import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useUserDesc } from '../shared/use-user-desc';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { FC } from 'react';

export const OG: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const description = useUserDesc();

  if (!user) {
    return null;
  }

  const { avatar, nickName, linkName } = user;
  const { region } = useAtomValue($Locale);
  const ogUrl = `/${linkName}?region=${region}`;

  return (
    <>
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={nickName} />
      <meta property="og:description" content={description} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image" content={avatar} />
    </>
  );
};
